/**
 * Centralized access to OmniWound web environment variables. Always import
 * this object instead of touching `import.meta.env` directly so the runtime
 * surface is captured in one place.
 */
type Environment = {
  env: string;
  bffBaseUrl: string;
  auth: {
    url: string;
    realm: string;
    clientId: string;
  };
  isLocal: () => boolean;
  isProduction: () => boolean;
};

const env: Environment = {
  env: import.meta.env['VITE_ENVIRONMENT'] ?? 'local',
  bffBaseUrl:
    import.meta.env['VITE_BFF_BASE_URL'] ?? 'http://localhost:9164/trpc',
  auth: {
    url: import.meta.env['VITE_KEYCLOAK_URL'] ?? 'http://localhost:8180',
    realm: import.meta.env['VITE_KEYCLOAK_REALM'] ?? 'omniwound-local',
    clientId:
      import.meta.env['VITE_KEYCLOAK_CLIENT_ID'] ?? 'omniwound-web-local',
  },
  isLocal: () => env.env === 'local',
  isProduction: () => env.env === 'production',
};

export default env;
